module.exports = __webpack_public_path__ + "img/bodyytalkanimal.2ba56139.svg";